import React, { useState } from 'react'
// import Button from '@mui/material/Button';
import leftarrow from "../../assets/Image/leftarrow.png"
import { useHistory } from "react-router";
import { useParams } from "react-router";
// import { getEntriesExport } from '../Services/ApiHandler';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { CSVLink } from "react-csv";

import "../../myfin_v2/css/bookclosure.css";
import { Button } from "../../myfin_v2/elements/Button";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
// import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/download.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";



const AdjustmentsNav = ({
    setFilterShow,
    csvLink
}) => {

    const breadcrumbItems = [
        {
            label: "Workspace",
            link: `/adjustments`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Standalone",
            link: `/adjustments`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "Adjustment Log", link: "", className: "headerLable" },
    ];
    return (
        <>
            <div className="fscp-header">
                <Breadcrumb style="margin-right:auto"
                    addCls={"bgClr1"}
                    items={breadcrumbItems}
                    headerActions={<></>}
                />
                <SearchIcon width={18} height={18} className='mr-2' />
                <FilterIcon width={20} height={20} className={`mr-2 ${commoncss.clickable}`} onClick={()=>{setFilterShow(true)}} />
                <CSVLink {...csvLink}>
                    <Button
                        icon={<ExportIcon width={18} height={18} />}
                        btnColor={buttoncss.secondary}
                        class_={buttoncss.greyBg}
                        label={"Export"}
                    />
                </CSVLink>

            </div>
        </>
    )
}

export default AdjustmentsNav